import axios from './productInstance'
import mapLaserProfiles from '@/components/LaserProfile/loadData/mapLaserProfiles'
import { LaserProfileFormData } from '@/types/laserProfile'


const getLaserProfile = async (page: number = 1, size: number = 100): Promise<LaserProfileFormData[] | null> => {
	try {



		const response = await axios.get(`/laserprofiles/`, {
			params: { page, size },
		});
		return mapLaserProfiles(response.data.contents || []) ;



	} catch (error) {
		console.error("Error fetching laser profile data:", error);
		return null;
	}



};

export default getLaserProfile;
